module.exports = "<div class=\"footer\">\n  &copy;Logtek 2019\n</div>"